<template lang="pug">
  div
    div(v-if="isPara && isExisteParcela && antecipacaoAtiva && !dadosVtn.isQuitadoParcelas && !excedente && !resumo && dadosVtn.formaPagamento !== 'A_VISTA'")
      app-antecipacao-vtn(:dadosVtn="dadosVtn", :showGestaoVtn="true")
    app-divider(label="Dados Cálculo").margin10
    div(class="card-body margin10", v-if="isMaranhao")
      el-row(v-if="dadosVtn.municipio")
        el-col(:span="12")
          app-display(
            label="Município:",
            :content="dadosVtn.municipio.nome"
          )
        el-col(:span="12")
          app-display(
            label="Área requerida:",
            :content="`${formatarNumero(dadosVtn.areaRequerida, 4)} ${isReurbIndividual ? 'm²': 'ha'}`"
          )
      el-row
        el-col(:span="12")
          app-display(
            :label="`Valor de referência por ${isReurbIndividual ? 'm²': 'ha'}:`",
            :content="`R$ ${formatarNumero(dadosVtn.calculosVtn.valorReferencia, 2)}`"
          )
        el-col(:span="12")
          app-display(
            label="VTN:",
            :content="`R$ ${formatarNumero(dadosVtn.calculosVtn.valorVtn, 2)}`"
          )
      el-row
        el-col(:span="12")
          app-display(
            label="Taxas diversas:",
            :content="`R$ ${dadosVtn.calculosVtn.taxaDiversa ? formatarNumero(dadosVtn.calculosVtn.valorVtn * 0.1, 2) : '0,00'}`"
          )
        el-col(:span="12")
          app-display(
            label="Valor de referência do imóvel:",
            :content="`R$ ${formatarNumero(dadosVtn.calculosVtn.valorReferenciaImovel, 2)}`"
          )
    div(class="card-body margin10", v-if="!parcelasGeo && !isMaranhao")
      el-row(v-if="dadosVtn.municipio")
        el-col(:span="12")
          app-display(
            label="Município:",
            :content="dadosVtn.municipio.nome"
          )
        el-col(:span="12")
          app-display(
            label="Região:",
            :content="dadosVtn.municipio.regiao"
          )
      el-row
        el-col(:span="12")
          app-display(
            label="Sr - Área requerida:",
            v-if="dadosVtn.areaRequerida"
            :content="`${formatarNumero(dadosVtn.areaRequerida, 4)} ha`"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.fatorDistancia && dadosVtn.fatorDistancia.indice"
            label="IFa - Distância:",
            :content="dadosVtn.fatorDistancia.indice | formatDouble"
            :textIcon="dadosVtn.fatorDistancia.descricao"
            :toolTip="'right'"
          )
      el-row
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.fatorAcesso"
            label="IFb - Acesso à área:",
            :content="dadosVtn.fatorAcesso.indice | formatDouble"
            :textIcon="dadosVtn.fatorAcesso.descricao"
            :toolTip="'right'"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.fatorTempoOcupacao"
            label="IFc - Ancianidade da ocupação:",
            :content="dadosVtn.fatorTempoOcupacao.indice | formatDouble"
            :textIcon="dadosVtn.fatorTempoOcupacao.descricao"
            :toolTip="'right'"
          )
      el-row(v-if="dadosVtn.calculosVtn && !excedente")
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.vdr"
            label="VDR - Valor de referência correspondente à dimensão da propriedade:",
            :content="dadosVtn.vdr | formatDouble"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.indiceArea"
            label="IFd - Dimensão da área:",
            :content="dadosVtn.calculosVtn.indiceArea | formatDouble"
            :textIcon="textoIfd"
            :toolTip="'top'"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.numeroMf"
            label="Número de módulos fiscais:",
            :content="dadosVtn.calculosVtn.numeroMf | formatDouble"
            :textIcon="'Área requerida / MF'"
            :toolTip="'right'"
          )
      el-row(v-if="dadosVtn.calculosVtn")
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.mf"
            label="MF - Módulo fiscal do município:",
            :content="dadosVtn.calculosVtn.mf | formatDouble"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.vrt"
            label="VrT - Valor de Referência da terra para o município:",
            :content="formatTotal(dadosVtn.calculosVtn.vrt)"
          )
      el-row(v-if="dadosVtn.calculosVtn")
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.vtn"
            label="VTN - Valor da terra nua:",
            :content="formatTotal(dadosVtn.calculosVtn.vtn)"
            :textIcon="dadosVtn.calculosVtn.formulaCalculoVTN"
            :toolTip="'right'"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.vtn"
            label="Tempo de ocupação:",
            :content="formataAnos(dadosVtn.calculosVtn.tempoDeOcupacao)"
            :textIcon="'Tempo de ocupação em anos'"
            :toolTip="'right'"
          )
      el-row(v-if="dadosVtn.calculosVtn")
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.valorTotalCustasProcessuais"
            label="Custas processuais:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTotalCustasProcessuais)"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.valorTotalCustasAgrarias"
            label="Custas agrárias:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTotalCustasAgrarias)"
          )
      el-row(v-if="dadosVtn.calculosVtn")
        el-col(:span="12")
          app-display(
            v-if="tipoProcesso === 'ONEROSO'"
            label="Taxa de ocupação:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTaxaOcupacao)"
            :textIcon="'Para áreas até 100 ha não será cobrado taxa de ocupação. Para as demais, a taxa de ocupação será calculada pela fórmula VTN*(Tempo de ocupação/200)'"
            :toolTip="'right'"
          )
        el-col(:span="12")
          app-display(
            v-if="!dadosVtn.calculosVtn.valorTotalCustasProcessuais"
            label="Custas processuais:",
            :content="excedente? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTotalCustasProcessuais)"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.valorVistoriaRemota"
            label="Custas vistoria remota:",
            :content="formatTotal(dadosVtn.calculosVtn.valorVistoriaRemota)"
            :textIcon="'Valor referente a elaboração da vistoria remota'"
            :toolTip="'right'"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.valorVistoriaRemota"
            label="Custas vistoria remota:",
            :content="formatTotal(dadosVtn.calculosVtn.valorVistoriaRemota)"
            :textIcon="'Valor referente a elaboração da vistoria remota'"
            :toolTip="'right'"
          )
    div(class="card-body margin10", v-else-if="!isMaranhao")
      div(v-for="parcela in parcelasGeo")
        el-row(v-if="parcela.municipio")
            el-col(:span="12")
              app-display(
                label="Município:",
                :content="parcela.municipio.nome"
              )
            el-col(:span="12")
              app-display(
                label="Região:",
                :content="parcela.municipio.regiao"
              )
        el-row
          el-col(:span="12")
            app-display(
              label="Sr - Área requerida:",
              v-if="parcela.areaRequerida"
              :content="`${isSegundoExcedente > 0 ? formatarNumero(areaExcedente, 4) : formatarNumero(parcela.areaRequerida, 4)} ha`"
            )
          el-col(:span="12")
            app-display(
              v-if="parcela.fatorDistancia && parcela.fatorDistancia.indice"
              label="IFa - Distância:",
              :content="parcela.fatorDistancia.indice | formatDouble"
              :textIcon="parcela.fatorDistancia.descricao"
              :toolTip="'right'"
            )
        el-row
          el-col(:span="12")
            app-display(
              v-if="parcela.fatorAcesso"
              label="IFb - Acesso à área:",
              :content="parcela.fatorAcesso.indice | formatDouble"
              :textIcon="parcela.fatorAcesso.descricao"
              :toolTip="'right'"
            )
          el-col(:span="12")
            app-display(
              v-if="dadosVtn.fatorTempoOcupacao"
              label="IFc - Ancianidade da ocupação:",
              :content="dadosVtn.fatorTempoOcupacao.indice | formatDouble"
              :textIcon="dadosVtn.fatorTempoOcupacao.descricao"
              :toolTip="'right'"
            )
        el-row(v-if="parcela.vdr")
          el-col(:span="12")
            app-display(
              v-if="parcela.vdr"
              label="VDR - Valor de referência correspondente à dimensão da propriedade:",
              :content="parcela.vdr | formatDouble"
            )
          el-col(:span="12")
            app-display(
              v-if="parcela.indiceArea"
              label="IFd - Dimensão da área:",
              :content="parcela.indiceArea | formatDouble"
              :textIcon="textoIfd"
              :toolTip="'top'"
            )
          el-col(:span="12")
            app-display(
              v-if="parcela.numeroMf"
              label="Número de módulos fiscais:",
              :content="parcela.numeroMf | formatDouble"
              :textIcon="'Área requerida / MF'"
              :toolTip="'right'"
            )
        el-row(v-if="parcela")
          el-col(:span="12")
            app-display(
              v-if="parcela.mf"
              label="MF - Módulo fiscal do município:",
              :content="parcela.mf | formatDouble"
            )
          el-col(:span="12")
            app-display(
              v-if="parcela.vrt"
              label="VrT - Valor de Referência da terra para o município:",
              :content="formatTotal(parcela.vrt)"
            )
          el-col(:span="12")
            app-display(
              label="VTN - Valor da terra nua:",
              :content="`${isSegundoExcedente > 0 ? formatTotal(valorTerraNua) : formatTotal(parcela.vtn)}`"
              :textIcon="dadosVtn.calculosVtn.formulaCalculoVTN"
              :toolTip="'right'"
            )
        el-row
          el-col(:span="12")
            app-display(
              label="Tempo de ocupação:",
              :content="formataAnos(parcela.tempoDeOcupacao)"
              :textIcon="'Tempo de ocupação em anos'"
              :toolTip="'right'"
            )
      hr
    div(v-if="parcelasGeo")
      el-row
        el-col(:span="12")
          app-display(
            label="Custas processuais:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTotalCustasProcessuais)"
          )
        el-col(:span="12")
          app-display(
            label="Custas agrárias:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTotalCustasAgrarias)"
          )
      el-row
        el-col(:span="12")
          app-display(
            v-if="tipoProcesso === 'ONEROSO'"
            label="Taxa de ocupação:",
            :content="isExcedente ? 'R$ 0,00' : formatTotal(dadosVtn.calculosVtn.valorTaxaOcupacao)"
            :textIcon="'Para áreas até 100 ha não será cobrado taxa de ocupação. Para as demais, a taxa de ocupação será calculada pela fórmula VTN*(Tempo de ocupação/200)'"
            :toolTip="'right'"
          )
        el-col(:span="12")
          app-display(
            v-if="dadosVtn.calculosVtn.valorVistoriaRemota"
            label="Custas vistoria remota:",
            :content="formatTotal(dadosVtn.calculosVtn.valorVistoriaRemota)",
            :textIcon="'Valor referente a elaboração da vistoria remota'"
            :toolTip="'right'"
          )

    app-divider(v-if="!isMaranhao" label="Observações:").margin10
    div(v-if="!isMaranhao" class="card-body margin10")
      p - Cálculos efetuados com base no DECRETO Nº 1.684, de 29 de JUNHO de 2021; Lei Estadual nº 8.878, de 8 de julho de 2019 e DECRETO Nº 1.190, DE 25 / 11 / 2020.
      p(v-if="!isExcedente && tipoProcesso === 'ONEROSO'") - Reajuste pela UPFPA do ano em vigor e, caso opte pelo pagamento parcelado, serão aplicados juros de {{dadosVtn.juros === null ? 0 : dadosVtn.juros}}% ao ano.
      p(v-if="!isExcedente && tipoProcesso === 'ONEROSO' && !(dadosVtn.respeitaLegislacaoAmbiental && dadosVtn.temDireitoRegularizacao)") - Caso opte pelo pagamento à vista, será aplicado um desconto de 20%.
      p(v-if="!isExcedente && dadosVtn.respeitaLegislacaoAmbiental") - {{mensagemRespeitaLegislacaoAmbiental}}
      p(v-if="!isExcedente && dadosVtn.temDireitoRegularizacao") - {{mensagemDireitoRegularizacao}}
</template>

<script>
import utils from '@/utils/utils'
import AppDisplay from '@/components/AppDisplay'
import AppLabel from '@/components/AppLabel'
import AppDivider from '@/components/AppDivider'
import messages from '@/constants/messages'
import AppAntecipacaoVtn from '../screens/central/components/centralMensagens/AppAntecipacaoVtn'
import { mapActions } from 'vuex'

export default {
  components: {
    AppDisplay,
    AppLabel,
    AppDivider,
    AppAntecipacaoVtn
  },

  props: {
    tipoProcesso: {
      type: String,
      required: true
    },
    resumo: {
      type: Boolean,
      default: false
    },
    calculoExcedente: {
      type: Boolean,
      default: false
    },
    visualizar: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      textoIfd: `
      Caso o número de módulos fiscais seja menor ou igual a um, ou maior ou igual a quinze, IFd = 1,17.\n
      Caso não se enquadre em nenhuma das condições anteriores, o IFd = 0,0571 * Número de Módulos Fiscais + 0,3129.`,
      mensagemDireitoRegularizacao: messages.TEM_DIREITO_REGULARIZACAO,
      mensagemRespeitaLegislacaoAmbiental: messages.RESPEITA_LEGISLACAO_AMBIENTAL,
      isPara: process.env.ESTADO === 'pa',
      isMaranhao: process.env.ESTADO === 'ma',
      dadosProcesso: null,
      isExisteParcela: null,
      antecipacaoAtiva: false,
      excedente: false,
      valorTerraNua: 0,
      areaExcedente: 0,
      indexExcedente: 0
    }
  },

  created () {
    this.isExisteParcelaVtn()
    this.getFeaturesSistema().then(r => { this.antecipacaoAtiva = r.antecipacacaoVtnAtiva })
    this.tratativaExcedente()
  },

  methods: {
    ...mapActions({
      existeParcelaVtn: 'dae/existeParcelaByIdVtn',
      getFeaturesSistema: 'features/getFeaturesSistema'

    }),
    formatTotal (valor) {
      return utils.padraoMoedaBrasil.format(valor)
    },

    async isExisteParcelaVtn () {
      const idVtn = this.$store.state.vtn?.dadosVtn?.id
      if (idVtn) {
        this.isExisteParcela = await this.existeParcelaVtn(idVtn)
      }
    },

    formatarNumero (val, precision) {
      return utils.format(val, { prefix: '', suffix: '', thousands: '.', decimal: ',', precision })
    },

    formataAnos: (valor) => valor > 1 ? `${valor} anos` : `${valor} ano`,

    hasAreaExcedente () {
      if (this.indexExcedente === undefined) {
        this.indexExcedente = 0
      }
      return !!(this.dadosVtn.calculosVtn.resumoParcelaExcedente != null &&
              this.dadosVtn.calculosVtn.resumoParcelaExcedente[this.indexExcedente] &&
              this.dadosVtn.calculosVtn.resumoParcelaExcedente[this.indexExcedente].areaExcedente)
    },

    tratativaExcedente () {
      this.indexExcedente = this.$route.params.index
      if (this.$route.params.excedente || this.dadosVtn.calculosVtn.resumoParcelaExcedente != null) {
        this.excedente = this.$route.params.excedente !== undefined ? this.$route.params.excedente
          : this.hasAreaExcedente()
      }
      if (this.indexExcedente > 0) {
        this.areaExcedente = this.dadosVtn.calculosVtn.resumoParcelaExcedente[this.indexExcedente].areaExcedente
        this.valorTerraNua = this.dadosVtn.calculosVtn.resumoParcelaExcedente[this.indexExcedente].valor
      }
    }
  },

  computed: {
    dadosVtn () {
      return this.$store.state.vtn?.dadosVtn
    },
    parcelasGeo () {
      return this.$store.state.vtn.dadosVtn?.calculosVtn?.dadosParcelaGeoVtn
    },
    isExcedente () {
      if (this.visualizar) {
        return false
      }
      if (this.$route.fullPath.includes('/financeiro/cof/detalhesProcesso/calculoPagamento')) {
        return false
      }
      if (this.calculoExcedente) {
        return this.calculoExcedente
      }
      return this.excedente
    },
    isSegundoExcedente () {
      return this.$store.state.vtn.dadosVtn?.calculosVtn?.dadosParcelaGeoVtn.length === 1 &&
      this.indexExcedente > 0
    },
    isReurbIndividual () {
      return ['REURB_INDIVIDUAL'].includes(this.tipoProcesso)
    }
  }
}
</script>

<style>

  .conteudo {
    margin: 0px 15px;
    text-align: left;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    color: #2c3e50;
  }

  .dataLimite {
    margin-top: 20px;
  }

  .flex {
    display: flex;
    justify-content: space-between;
  }

  .title {
    font-weight: 400;
  }

  .card {
    margin-top: 5;
  }

  .row {
    display: flex;
    flex-direction: row;
  }

  .aling-center {
    display: flex;
    flex-direction: row;
    justify-content: center;
    text-align: center;
  }

  .margin10 {
    margin: 10px;
  }

  .card .card-header {
    font-size: x-large;
    line-height: initial;
    padding: 23px 23px 0 23px;
  }

</style>



// WEBPACK FOOTER //
// src/components/AppDadosCalculoVtn.vue